import React from 'react'
import Main from "./Main";

export default class MainApp extends React.Component {
    state = {
        loading: true
    };

    componentDidMount() {
        // this simulates an async action, after which the component will render the content
        demoAsyncCall().then(() => this.setState({ loading: false }));
    }

    render() {
        const { loading } = this.state;
        if(loading) { // if your component doesn't have to wait for async data, remove this block
            return null; // render null when app is not ready
        }

        return (
            <Main/>
        );
    }
}

function demoAsyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
